import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const Wrapper = styled("div")`
    margin: 2rem 0;
    padding: 2rem;
    background-color: #8080806e;

    @media (min-width: ${breakpoints.values.md}px) {
        display: block;
    }
`

export const TitleWrapper = styled("div")`
    font-size: 1.2rem;
    font-weight: 500;
`

export const RequestTextWrapper = styled("div")`
    margin-top: 1rem;
    word-break: break-all;
`
